import PropTypes from 'prop-types'
import React from 'react'
import Icon from 'components/Icon'
import { Vignette } from 'components/Vignette'
import { AvatarIcon } from 'components/Icon/icons/avatar'
import { View } from 'components/View'

export const UserAvatar = ({
  value,
  size = Icon.SIZE.SMALLER,
  style = {},
  shouldLazyLoad = true
}) => {
  return (
    <View
      style={{
        alignItems: View.ALIGN.CENTER,
        justifyContent: View.JUSTIFY.CENTER,
        ...style
      }}
    >
      {value
        ? (
          <Vignette
            name='avatar'
            size={size}
            source={value}
            shouldLazyLoad={shouldLazyLoad}
          />
          )
        : (
          <div className='userAvatar-placeholder'>
            <Icon
              icon={AvatarIcon}
              size={size}
            />
          </div>
          )}
    </View>
  )
}

UserAvatar.SIZE = Icon.SIZE
UserAvatar.propTypes = {
  value: PropTypes.string,
  size: PropTypes.oneOf(
    Object.values(UserAvatar.SIZE)
  ),
  style: PropTypes.object.isRequired
}
